<style>
  /* Background image disabled. Original rule kept for reference:
  background-image: url('../../../assets/img/europe.jpg');
  background-size: cover;
  */
  .login-page {
    min-height: 100vh;
    background: #f0f3f8;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
  }

  .login-card {
    width: 100%;
    max-width: 420px;
    background: #ffffff;
    border: 1px solid #dfe4ec;
    border-top: 4px solid #0b2a6f;
    border-radius: 6px;
    box-shadow: 0 6px 24px rgba(11, 42, 111, 0.08);
    padding: 32px 32px 24px;
  }

  .login-title {
    font-size: 22px;
    font-weight: 600;
    color: #0b2a6f;
    margin: 0 0 4px;
  }

  .login-subtitle {
    font-size: 14px;
    color: #6b7280;
    margin: 0 0 24px;
  }

  .login-card label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 6px;
  }

  .login-card .input-group-text {
    background: #f7f9fc;
    border-color: #d1d7e0;
    color: #6b7280;
  }

  .login-card .form-control {
    border-color: #d1d7e0;
    font-size: 15px;
    height: 44px;
  }

  .login-card .form-control:focus {
    border-color: #0b2a6f;
    box-shadow: 0 0 0 3px rgba(11, 42, 111, 0.12);
  }

  .login-submit {
    width: 100%;
    height: 44px;
    background: #0b2a6f !important;
    border: none;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  .login-submit:hover {
    background: #081f52 !important;
  }

  .login-help {
    font-size: 13px;
    color: #6b7280;
    text-align: center;
    margin: 20px 0 0;
  }

  .login-help a {
    color: #0b2a6f;
    font-weight: 600;
  }
</style>

<div class="login-page">
  <div class="login-card">
    <h1 class="login-title">Sign in</h1>
    <p class="login-subtitle">Enter your credentials to access the dashboard</p>

    <form [formGroup]="loginForm" (ngSubmit)="goLogin()">
      <div class="form-group mb-3">
        <label for="email">Email</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="icon-user"></i></span>
          </div>
          <input
            id="email"
            (keydown.space)="$event.preventDefault()"
            class="form-control"
            autocomplete="off"
            placeholder="name@example.com"
            formControlName="email"
            type="text"
            [(ngModel)]="model.email"
            [ngClass]="{ 'is-invalid': submitted && lf.email.errors }"
          />
          <div *ngIf="submitted && lf.email.errors" class="invalid-feedback">
            <div *ngIf="lf.email.errors.required">Please enter email.</div>
            <div *ngIf="lf.email.errors.pattern">Please enter valid email.</div>
          </div>
        </div>
      </div>

      <div class="form-group mb-4">
        <label for="password1">Password</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="icon-lock"></i></span>
          </div>
          <input
            input
            id="password1"
            class="form-control"
            type="password"
            autocomplete="off"
            placeholder="Enter your password"
            formControlName="password"
            [(ngModel)]="model.password"
            [ngClass]="{ 'is-invalid': submitted && lf.password.errors }"
          />
          <div *ngIf="submitted && lf.password.errors" class="invalid-feedback">
            <div
              *ngIf="lf.password.errors.required || lf.password.errors.whiteSpace"
            >
              Please enter password.
            </div>
            <div *ngIf="lf.password.errors.minlength">
              Password length must be at least 5 characters long.
            </div>
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary login-submit">Sign in</button>

      <p class="login-help">
        Forgot your password? Reset it on AU Login.
      </p>
    </form>
  </div>
</div>
